import React from 'react'
import { BarChart3, Lightbulb, Palette, MessageCircle, Target, Wand2 } from 'lucide-react'

type TabId = 'overview' | 'brand-strategy' | 'visual-identity' | 'brand-messaging' | 'toolbox' | 'ai-assets'

interface TabNavigationProps {
  selectedTab: TabId
  onTabChange: (tab: TabId) => void
}

const TAB_CONFIG = [
  { id: 'overview' as const, label: 'Overview', icon: BarChart3 },
  { id: 'brand-strategy' as const, label: 'Brand Strategy', icon: Lightbulb },
  { id: 'visual-identity' as const, label: 'Visual Identity', icon: Palette },
  { id: 'brand-messaging' as const, label: 'Brand Messaging', icon: MessageCircle },
  { id: 'toolbox' as const, label: 'Toolbox', icon: Target },
  { id: 'ai-assets' as const, label: 'AI Assets', icon: Wand2 }
]

export function TabNavigation({ selectedTab, onTabChange }: TabNavigationProps) {
  return (
    <div className="flex items-center space-x-6 mb-8 border-b border-slate-200">
      {TAB_CONFIG.map((tab) => {
        const Icon = tab.icon
        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`flex items-center space-x-2 pb-3 border-b-2 transition-colors ${
              selectedTab === tab.id
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-slate-600 hover:text-slate-900'
            }`}
          >
            <Icon className="w-4 h-4" />
            <span className="font-medium">{tab.label}</span>
          </button>
        )
      })}
    </div>
  )
}

export type { TabId }